module.exports = __webpack_public_path__ + "static/media/info.94a43fda.svg";